module.exports = "<svg id=\"__1Dm1det__96045226-6cb8-4f76-abca-ca0268658dd4\" data-name=\"Home\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><title>donauhof</title><path d=\"M34,29.5H2v-18H34Zm0-23H2V9H34ZM35.5,9H.5v2.5h35ZM2,20.49H34m-8,9h4v-6H26ZM6,23v4m4-4v4m4-4v4m4-4v4m4-4v4M6,14v4m4-4v4m4-4v4m4-4v4m4-4v4m4-4v4m4-4v4\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/donauhof-home.svg
// module id = 176
// module chunks = 1